export default __webpack_public_path__ + "static/media/lm-image.916dc4d8.png";